export enum EstimateFile {
  TIC = "tic",
  IMAGE = "image",
  OTHER = "other",
  MITIGATION_REPORT = "mitigation_report",
  CONTENTS_TEMPLATE = "contents_template",
  XACTIMATE_ESTIMATE = "xactimate_estimate",
}

/** File types shown under the Documents tab and counted as documents on the dashboard. */
export const DOCUMENT_FILE_TYPES = [EstimateFile.OTHER, EstimateFile.MITIGATION_REPORT, EstimateFile.XACTIMATE_ESTIMATE];
